import { useState, useEffect } from 'react'
import useSession from 'querys/session'
import { useRouter } from 'next/router'
import LearningPlan from './learning-plan'
import LearningPlanProgress from './learning-plan-progress'
import LearningPlanVideoCard from './learning-plan-video-card'

function LearningPlanCourses() {
  const { asPath, push } = useRouter()
  const [course, setCourse] = useState({})
  const [itemActive, setItemActive] = useState('')
  const { token, isStale } = useSession()

  useEffect(() => {
    const handleResize = () => {
      if (window.matchMedia('(min-width: 1024px)').matches && asPath.includes('#stats')) {
        push('/aprender', { shallow: true })
      }
    }
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.addEventListener('resize', handleResize)
    }
  }, [])

  if (asPath.includes('#stats')) {
    return (
      <div className="learning-plan-grid-courses">
        <LearningPlanProgress />
      </div>
    )
  }

  return (
    <div className="learning-plan-grid-courses">
      <LearningPlan setCourse={setCourse} course={course} setItemActive={setItemActive} itemActive={itemActive} />
      {
        !isStale ? (
          token ? (
            <LearningPlanProgress />
          ) : (
            <LearningPlanVideoCard course={course} />
          )
        ) : null
      }
    </div>
  )
}

export default LearningPlanCourses
